import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

// Zavi FC operates in India — pin all "current date/month" business logic to
// Asia/Kolkata so a request made at 30 Sep 11:59 PM IST is still September and
// 1 Oct 12:00 AM IST rolls to October, regardless of device timezone.
export const IST_TZ = "Asia/Kolkata";
const _istParts = (d = new Date()) => {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: IST_TZ, year: "numeric", month: "2-digit", day: "2-digit",
  }).formatToParts(d);
  const out = {};
  parts.forEach((p) => { if (p.type !== "literal") out[p.type] = p.value; });
  return out; // { year, month, day } as zero-padded strings
};

export const currentMonth = () => {
  const p = _istParts();
  return `${p.year}-${p.month}`;
};

export const currentDate = () => {
  const p = _istParts();
  return `${p.year}-${p.month}-${p.day}`;
};

export const monthLabel = (m) =>
  new Date(Number(m.slice(0, 4)), Number(m.slice(5, 7)) - 1, 1).toLocaleString("en-IN", { month: "long", year: "numeric" });

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").filter(Boolean).join(" ");
  return "Something went wrong. Please try again.";
}

export const FEE_LABELS = { group: "Group Sessions", transport: "Transport", pt: "Personal Training", previous_dues: "Previous Dues", registration: "Registration Fee", extra: "Additional Charges" };

const QUARTER_NAMES = ["Jan - Mar", "Apr - Jun", "Jul - Sep", "Oct - Dec"];

export const quarterOfMonth = (m) => `${m.slice(0, 4)}-Q${Math.ceil(Number(m.slice(5, 7)) / 3)}`;

export const currentQuarter = () => quarterOfMonth(currentMonth());

export const quarterLabel = (q) => {
  const [y, qs] = q.split("-Q");
  return `${QUARTER_NAMES[Number(qs) - 1]} ${y}`;
};

export const quarterOptions = (count = 8) => {
  const p = _istParts();
  let y = Number(p.year);
  let q = Math.ceil(Number(p.month) / 3) + 1;
  if (q > 4) { q = 1; y += 1; }
  const out = [];
  for (let i = 0; i < count; i++) {
    out.unshift(`${y}-Q${q}`);
    q -= 1;
    if (q < 1) { q = 4; y -= 1; }
  }
  return out.reverse();
};
